import { TablePaginationConfig } from '../interfaces/table-pagination.interface';

export const TABLE_PAGINATION_TOTAL_ITEMS = 0;
export const TABLE_PAGINATION_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const TABLE_PAGINATION_PAGE_SIZE = 10;
export const TABLE_PAGINATION_CURRENT_PAGE = 1;

export const TABLE_PAGINATION_DEFAULT_CONFIG: TablePaginationConfig = {
  totalItems: TABLE_PAGINATION_TOTAL_ITEMS,
  pageSizeOptions: TABLE_PAGINATION_PAGE_SIZE_OPTIONS,
  pageSize: TABLE_PAGINATION_PAGE_SIZE,
  currentPage: TABLE_PAGINATION_CURRENT_PAGE,
};
